module.exports = __webpack_public_path__ + "img/US_BonusDamagevsBuilding_ua.2db008cd.webp";